import {Select} from '@mantine/core'

import {useCustomerSavedLocations} from 'src/customers/saved-locations/use-saved-locations'

type SavedLocationSelectorProps = {
    customerId: string
    value: string | null
    onChange: (savedLocationId: string | null) => void
    error?: string
    disabled?: boolean
}

export function SavedLocationSelector({
    customerId,
    value,
    onChange,
    error,
    disabled,
}: SavedLocationSelectorProps) {
    const {data: savedLocations = [], isLoading} = useCustomerSavedLocations(customerId)

    const options = savedLocations.map((location) => ({
        value: location.id,
        label: location.name,
    }))

    return (
        <Select
            label="Saved location"
            placeholder="Select a saved location"
            data={options}
            value={value ?? undefined}
            onChange={(val) => onChange(val ?? null)}
            error={error}
            disabled={disabled || isLoading}
            clearable
            searchable
        />
    )
}
